import { render, staticRenderFns } from "./autocomplete.vue?vue&type=template&id=bd5bd564&scoped=true"
import script from "./autocomplete.vue?vue&type=script&lang=js"
export * from "./autocomplete.vue?vue&type=script&lang=js"
import style0 from "./autocomplete.vue?vue&type=style&index=0&id=bd5bd564&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd5bd564",
  null
  
)

export default component.exports